/**
 * Modelo de classe para representar os procedimentos.
 */
export class Procedimento {
    id: number;
    nome: string;
    codigo: string;
    valorUnitario: number;
    ativo: boolean;
  }
